import { stateT } from "../types";
import {
  EInterfaceContent,
  EServerStatus,
  IInnerLoaders,
  modalsListT,
  ModalStatusT,
  NameModals,
} from "./appTypes";

export const getIsShowLoader =
  () =>
  ({ ...state }: stateT) => {
    const isShowLoader: boolean = state.app.isShowLoader;
    return isShowLoader;
  };

export const getIsShowInnerLoader =
  () =>
  ({ ...state }: stateT) => {
    const innerLoaders: IInnerLoaders = state.app.innerLoaders;
    return innerLoaders;
  };

export const getStateModal =
  (nameModal: NameModals) =>
  ({ ...state }: stateT) => {
    const modalList: modalsListT = state.app.modalsList;
    const selectedModal: ModalStatusT = modalList[nameModal];

    return { name: nameModal, data: selectedModal };
  };

export const getServerStatus =
  () =>
  ({ ...state }: stateT) => {
    const serverStatus: EServerStatus = state.app.serverStatus;
    return serverStatus;
  };

export const getWsStatus =
  () =>
  ({ ...state }: stateT) => {
    const wsConnected: boolean = state.app.wsConnected;
    return wsConnected;
  };

export const getInterfaceContent =
  () =>
  ({ ...state }: stateT) => {
    const interfaceContent: EInterfaceContent = state.app.interfaceContent;

    return interfaceContent;
  };

export const getSceneHintState =
  () =>
  ({ ...state }: stateT) => {
    const sceneHintModal: ModalStatusT = state.app.modalsList.sceneHint;
    return sceneHintModal;
  };

export const getResetSceneState =
  () =>
  ({ ...state }: stateT) => {
    const resetSceneModal: ModalStatusT = state.app.modalsList.resetScene;
    return resetSceneModal;
  };

export const getIsToolbarReady =
  () =>
  ({ ...state }: stateT) => {
    return state.app.isToolbarReady;
  };

export const getIsShowOverlayHint =
  () =>
  ({ ...state }: stateT) => {
    return state.app.isShowOverlayHint;
  };
